import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unreadCount'
})
export class UnreadCountPipe implements PipeTransform {
  transform(value: number): string {
    if (value > 999) {
      return '1k+';
    } else if (value > 99) {
      return '99+';
    }
    return value ? value.toString() : '';
  }
}
